import { createContext } from 'react'
import { Context } from './reservation-context.types'

export const ReservationContext = createContext<Context>({
  reservation: undefined as any,
  reservedResources: new Map(),
  checkInWarning: {
    isGroup: false,
    warning: {
      wrongGuestType: false,
      moreThanOneGuarantor: false,
      missingGuarantor: false,
      missingNotGuarantor: false,
    },
    error: {
      noResources: false,
    },
    reservedResources: [],
  },
  loading: false,
  submitReservedResource: async () => {
    return
  },
  submitReduceGuestCount: async () => {
    return
  },
  submitAddGuest: async () => {
    return
  },
  guestOccupanciesErrorShown: () => {
    return
  },
  onGuestChange: () => {
    return
  },
  onCustomerUpserted: () => {
    return
  },
  customerErrorShown: () => {
    return
  },
  cancelChanges: () => {
    return
  },
  performGuestCheckinCheckout: () => {
    return
  },
})
